import { Alerts } from "../../../../utils/Alerts.js";
import { useToggle } from "../../../../hooks/useToggle.js";
import "react";
import { ActionModal, Button } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
// src/modules/Users/shared/UserAuthSessionsTable/TableControls.tsx
function UserAuthSessionsTableControls({ clearSelectedRows, onKillSelectedAuthSessions, selectedRowsKeys }) {
	const [showDeleteModal, toggleShowDeleteModal] = useToggle(false);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", {
		className: "flex w-full flex-col",
		children: /* @__PURE__ */ jsx("div", {
			className: "m-xxs gap-x-xs inline-flex items-center",
			children: selectedRowsKeys?.length > 0 && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
				className: "text-color-subtle min-w-fit text-sm",
				children: [selectedRowsKeys?.length, " Selected"]
			}), /* @__PURE__ */ jsx("div", {
				className: "min-w-fit",
				children: /* @__PURE__ */ jsx(Button, {
					onClick: () => toggleShowDeleteModal(),
					size: "sm",
					variant: "critical",
					children: "Kill Sessions"
				})
			})] })
		})
	}), showDeleteModal && onKillSelectedAuthSessions && /* @__PURE__ */ jsx(ActionModal, {
		actionText: "Kill Device Sessions",
		body: "Selected devices will be logged out as a result of this action. This could result in lost data that has not yet been uploaded.",
		onCancel: toggleShowDeleteModal,
		onAction: async () => {
			try {
				await onKillSelectedAuthSessions(selectedRowsKeys);
				clearSelectedRows();
				Alerts.success(`Device sessions have been killed`);
			} catch (err) {
				Alerts.error("There was a problem killing device sessions", err.message);
				console.log("kill err", err);
			}
		},
		title: "Kill User Device Sessions",
		variant: "critical"
	})] });
}
export { UserAuthSessionsTableControls };

//# sourceMappingURL=TableControls.js.map